import React, {useEffect, useState} from 'react';
import {list} from "cart-localstorage";

const MyGallery  = ({listData}) => {

    const [isZoom, setIsZoom] = useState(false);
    const [indexZoom, setIndexZoom] = useState()
    const zoomFunc = (value) => {
      
      console.info("IMAGE:", value )
        setIndexZoom(value)
      /*
      {()=>{zoomFunc(index)}}
      * */
    }


    useEffect(() => {
        console.info("List length", listData.length);
    }, []);
    
    
    return (
        <div className='w-100 nice-container-fluid'>
            <div className="nice-row nice-center">

                {
                    listData?.map((item, index) => {
                        return (
                            <div className="mx-3 my-5" key={index} >
                                <div className="nice-border">
                                        {/*<a href={'data:image/png;base64,' + item}>*/}
                                            <img src={'data:image/png;base64,' + item}  onClick={()=>{
                                                zoomFunc(index)
                                            }}
                                                 alt={item}
                                                 className=
                                                     {`rounded mx-0 my-4 img-fluid rounded-3 ${indexZoom == index ?'':'my-box-image'}`}
                                            />
                                        {/*</a>*/}
                                    
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

export default MyGallery ;
